import React, {Component} from "react";
import Table from "../../components/Table";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS, List, Map, Set} from "immutable";
import {graphql} from "react-apollo";
import gql from "graphql-tag";
// import "./ProductDistributionCountry.css";

function calcTotal(data, inventoryProducts) {
  return data.reduce((acc, x) => {
    return x.get("products").reduce((acc2, product) => {
      return acc2.update(product.get("sku"), 0, (value) => value + product.get("qty"))
    }, acc);
  }, Map())
  .reduce((acc, value, key) => {
    return acc.push(
      Map()
      .set("sku", key)
      .set("qty", value)
      .set("weight", inventoryProducts.get(key, 0) * value)
      );
  }, List([]))
  .sortBy((item) => item.get("sku"));
}

function getAllSkus(data) {
  return data.reduce((acc, x) => {
    return x.get("products").reduce((acc2, product) => {
      return acc2.add(product.get("sku"));
    }, acc)
  }, Set([]))
  .sort();
}

function mapProducts(products) {
  return products.reduce((acc, product) => {
    return acc.set(product.get("sku"), product.get("qty"));
  }, Map());
}

function indexInventoryProducts(products) {
  return products.reduce((acc, product) => {
    return acc.set(product.get("sku"), product.get("weight"));
  }, Map());
}

class ProductDistributionCountry extends Component {

  render() {
    let {loading, error, shippingProductDistribution, products} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    let data = fromJS(shippingProductDistribution);
    let inventoryData = indexInventoryProducts(fromJS(products));
    let tableHeader = List([
      "SKU",
      "Quantity",
      "Weight (Kg)"
    ])          

    return (      
      <React.Fragment>
        <h2>{this.props.countryName}</h2>
        <p>Statistics show only <em>delivered</em> orders.</p>
        <h4>Totals</h4>
        <Table 
          data={calcTotal(data, inventoryData)} 
          renderer={TotalItem} 
          tableHeader={tableHeader}
          itemKey="sku"
          mode="table"
          />

        <h4>Monthly</h4>
        {this.renderMonthly(data)}
      </React.Fragment>
    )
  }

  renderMonthly(data) {
    let skus = getAllSkus(data);
    let tableHeader = List([
      "SKU", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ]);

    // Translate products to be map.
    let mappedData = data.map(x => {
      return x.set("products", mapProducts(x.get("products")));
    })
    // Index on month.
    .reduce((acc, x) => {
      return acc.set(x.get("month"), x);
    }, Map());

    let newData = skus.map(sku => {
      return Map({
        sku: sku,
        jan: mappedData.getIn([1, "products", sku], 0),
        feb: mappedData.getIn([2, "products", sku], 0),
        mar: mappedData.getIn([3, "products", sku], 0),
        apr: mappedData.getIn([4, "products", sku], 0),
        may: mappedData.getIn([5, "products", sku], 0),
        jun: mappedData.getIn([6, "products", sku], 0),
        jul: mappedData.getIn([7, "products", sku], 0),
        aug: mappedData.getIn([8, "products", sku], 0),
        sep: mappedData.getIn([9, "products", sku], 0),
        oct: mappedData.getIn([10, "products", sku], 0),
        nov: mappedData.getIn([11, "products", sku], 0),
        dec: mappedData.getIn([12, "products", sku], 0)
      });
    });

    return (
      <Table 
        data={newData} 
        renderer={MonthItem} 
        tableHeader={tableHeader}
        itemKey="sku"
        mode="table"
        />
    )
  }

}

const TotalItem = (props) => {
  return (
    <tr className="item">
      <td className="field f-id u-nowrap">{props.data.get("sku")}</td>
      <td className="field f-id">{props.data.get("qty")}</td>
      <td className="field f-id">{props.data.get("weight") / 1000} Kg</td>
    </tr>
  )
}

const MonthItem = ({data}) => {
  return (
    <tr className="item">
      <td className="field f-id u-nowrap">{data.get("sku")}</td>
      <td className="field f-id">{data.get("jan")}</td>
      <td className="field f-id">{data.get("feb")}</td>
      <td className="field f-id">{data.get("mar")}</td>
      <td className="field f-id">{data.get("apr")}</td>
      <td className="field f-id">{data.get("may")}</td>
      <td className="field f-id">{data.get("jun")}</td>
      <td className="field f-id">{data.get("jul")}</td>
      <td className="field f-id">{data.get("aug")}</td>
      <td className="field f-id">{data.get("sep")}</td>
      <td className="field f-id">{data.get("oct")}</td>
      <td className="field f-id">{data.get("nov")}</td>
      <td className="field f-id">{data.get("dec")}</td>
    </tr>
  )
}

const QUERY = gql`
  query productDistribution($countryCode:String, $year:Int!) {
    shippingProductDistribution(countryCode: $countryCode, year: $year) {
      countryCode,
      countryName,
      year
      month
      products {
        sku
        qty
      }
    }
    products {
      sku
      weight
    }    
  }
`


const withQuery = graphql(QUERY, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      countryCode: props.countryCode,
      year: props.year
    }
  })
})

export default withQuery(ProductDistributionCountry);
